
import {
    SET_USERS,
    SET_THERAPIST_EMAIL_LOG,
} from './types';

import { apiCallV2, servicesAPICall } from "../../utils/api";
import { removeDuplicates, removeValueInArray } from '../../utils';

export const GetUsers = (page, count, filter, sort) => async (dispatch, getState) => {
    dispatch({
        type: SET_USERS,
        data: {
            list: [],
        }
    })

    const res = await apiCallV2(
        "GET",
        "get-users",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: filter,
            sort: sort,
        },
    );

    if (res.status == 200) {
        dispatch({
            type: SET_USERS,
            data: {
                list: res.data.users,
                count: res.data.count[0]["count(*)"]
            }
        })
    }

}

export const AddNewUserToList = (user) => async (dispatch, getState) => {
    const { list, count } = getState().User;
    let temp = [...list];

    temp.unshift(user);

    dispatch({
        type: SET_USERS,
        data: {
            list: temp,
            count: count + 1
        }
    })
}


export const UpdateUserToList = (user, details) => async (dispatch, getState) => {
    const { list, count } = getState().User;
    let temp = [...list];

    temp = temp.map((l, i) => {
        return user.id != l.id
            ? l
            : {
                ...l,
                ...details
            }
    })

    dispatch({
        type: SET_USERS,
        data: {
            list: temp,
            count: count
        }
    })
}

export const RemoveUserToList = (user) => async (dispatch, getState) => {
    const { list, count } = getState().User;
    let temp = [...list];

    temp = temp.filter(l => l.id != user.id);

    dispatch({
        type: SET_USERS,
        data: {
            list: temp,
            count: count
        }
    })

}



export const ActivateTherapist = (details) => async (dispatch, getState) => {

    const res = await servicesAPICall(
        "POST",
        "clinicient/activate-therapist",
        details,
        localStorage.getItem("access-token"),
    );

    if (res?.status == 200) {
        return res?.data?.data;
    } else {
        return false;
    }

}

export const GetUsersTherapistEmailLog = (page, count, filter, sort) => async (dispatch, getState) => {
    dispatch({
        type: SET_THERAPIST_EMAIL_LOG,
        data: {
            list: [],
        }
    })

    const res = await apiCallV2(
        "GET",
        "admin/get-therapist-reminder-log",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: filter,
            sort: sort,
        },
    );

    // const list = res?.data?.therapistEmailLog?.map((therapist) => {
    //     return {
    //         ...therapist,
    //         sentEmailToPatients: therapist?.sentEmailToPatients ? removeDuplicates(JSON.parse(therapist?.sentEmailToPatients), "id") : [],
    //         patients: therapist?.patients ? removeDuplicates(JSON.parse(therapist?.patients)) : [],
    //     }
    // })

    let list = [];
    for (let x = 0; x < res?.data?.therapistEmailLog?.length; x++) {
        let therapist = res?.data?.therapistEmailLog[x];
        let sentEmailToPatients = therapist?.sentEmailToPatients ? removeDuplicates(JSON.parse(therapist?.sentEmailToPatients), "id") : [];
        let allPatients = therapist?.patients ? removeDuplicates(JSON.parse(therapist?.patients)) : [];
        let unsendPatients = [...allPatients];
        for (let y = 0; y < sentEmailToPatients.length; y++) {
            unsendPatients = removeValueInArray(unsendPatients, sentEmailToPatients[y]?.patient_id);
        }
        delete therapist?.patients;
        list.push({
            ...therapist,
            sentEmailToPatients: sentEmailToPatients,
            allPatients: allPatients,
            unsendPatients: unsendPatients
        })
    }


    if (res.status == 200) {
        dispatch({
            type: SET_THERAPIST_EMAIL_LOG,
            data: {
                list: list,
                count: res.data.count[0]["count(*)"]
            }
        })
    }

}

export const SendEmailToTherapist = ({
    htmlContent, subject, receipient, sender, userID, emailTemplate
}) => async (dispatch, getState) => {

    const res = await servicesAPICall(
        "POST",
        "indi-email/send",
        {
            html: htmlContent,
            subject: subject,
            receipient: receipient,
            user: userID,
            sender: "Buffalo Rehab Group <help@buffalorehab.com>",

            email: emailTemplate?.id,
            emailTemplate: emailTemplate,
        },
        localStorage.getItem("access-token"),
    );


    return res?.data?.success || false;
}